import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Space, Button, ConfigProvider, Radio, Divider, Row, Col, Result } from 'antd';
import { Spinner } from 'reactstrap';
import zhCN from 'antd/lib/locale/zh_CN';
import axios from '../../utils/request';
import moment from 'moment';
import 'moment/locale/zh-cn';
import UmRichEditor from "@beisen-phoenix/richeditor";
import { closeModel } from "../../utils";
moment.locale('zh-cn');


export class MaiRuiPhysicalExamination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            btnEnable: false,
            status: "error",
            errorMessage: "",
            title: "发送体检通知",
            applyId: "",
            physicalExaminationMsgTemplates: [],
            options: [
                { label: '邮件', value: 1 },
                { label: '短信', value: 2 },
                { label: '邮件+短信', value: 3 },
            ],
            sendType: null,
            emailContent: "",
            smsContent: "",
            msgTemplateCode: "",
        }
    };
    formRef = React.createRef()

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        if (!commonParamater) {
            this.setState({ errorMessage: "请求参数不存在！", isLoading: false, isReady: true });
            return;
        }
        this.loadPage(commonParamater);
    };

    loadPage = (commonParamater) => {
        const params = {
            commonParamater
        }
        axios
            .get("/api/MaiRuiPhysicalExamination/GetPhysicalExaminationIniData", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "获取体检通知模板失败！" + res.data.message
                } else {
                    if (resdata !== "") {
                        errorMessage = "";
                        let applyId = resdata.applyId;
                        let physicalExaminationMsgTemplates = resdata.physicalExaminationMsgTemplates;

                        this.setState({
                            applyId: applyId,
                            physicalExaminationMsgTemplates: physicalExaminationMsgTemplates
                        })
                    } else {
                        errorMessage = "获取体检通知模板失败！";
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage: errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
        );
    };

    onFinish = async (values) => {
        await this.formRef.current.validateFields().then(() => {
            this.setState({
                btnEnable: false,
            });

            let applyId = this.state.applyId;
            let templateCode = this.state.msgTemplateCode;
            let sendType = this.state.sendType;
            const params = {
                applyId,
                templateCode,
                sendType
            }
            const bodyString = JSON.stringify(params);
            axios
                .post("/api/MaiRuiPhysicalExamination/SendPhysicalExaminationMsg", bodyString, {
                    headers: { "Content-Type": "application/json" },
                })
                .then((res) => {
                    console.log(res)
                    const isSuccessValue = res.data.code == "200";
                    const resback = res.data.message;
                    let resdata = res.data.data;
                    let errorMessage = "";
                    if (!isSuccessValue) {
                        errorMessage = "提交失败！" + resback
                    }
                    else {
                        if (resdata !== "" && resdata !== null && resdata) {
                            errorMessage = "提交成功，具体发送结果请留意系统消息通知！";
                            this.setState({ status: "success" });
                        }
                        else {
                            errorMessage = "提交失败！";
                        }
                    }

                    if (errorMessage !== "") {
                        this.setState({ isLoading: false, isReady: true, errorMessage });
                    }
                })
                .catch((reason) => {
                    this.setState({
                        isLoading: false,
                        isReady: true,
                        errorMessage: "操作异常，请联系管理员！",
                    });
                })
                .finally();
        })
    };

    onRadioChange = (e) => {
        if (e.target.value !== null && e.target.value !== "") {
            this.setState({
                sendType: e.target.value,
            })
        }
    };

    getContentByTemplateCode = (templateCode) => {
        const params = {
            templateCode,
        }
        axios
            .get("/api/MaiRuiPhysicalExamination/GetTemplateContent", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "获取通知模板内容失败！" + res.data.message
                } else {
                    if (resdata !== null && resdata !== "") {
                        errorMessage = "";
                        let emailContent = "";
                        let smsContent = "";
                        if (resdata.email !== null) {
                            emailContent = resdata.email.content;
                        }
                        if (resdata.sms !== null) {
                            smsContent = resdata.sms.content;
                        }
                        this.setState({
                            emailContent: emailContent,
                            smsContent: smsContent,
                            btnEnable: true,
                            msgTemplateCode: templateCode,
                        }
                        )
                    } else {
                        errorMessage = "获取通知模板内容失败！";
                    }
                }

                if (errorMessage !== "") {
                    alert(errorMessage)
                    this.setState({
                        emailContent: "",
                        smsContent: "",
                    })
                }
            })
            .catch(reason => {
                alert("获取通知模板内容失败")
                this.setState({
                    emailContent: "",
                    smsContent: "",
                })
            })
            .finally(
        );
    };

    physicalExaminationMsgTemplateSelectedChanged = (value) => {
        this.setState({
            btnEnable: false,
        });
        if (value !== null && value !== "") {
            let msgTemplate = this.state.physicalExaminationMsgTemplates.find(
                (item) => item.code == value
            );
            if (msgTemplate !== null) {
                this.getContentByTemplateCode(msgTemplate.code);
            }
        }
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage) {
                return (
                    <Result
                    status={this.state.status}
                    title={this.state.title}
                        subTitle={this.state.errorMessage} />
               )
            }
            else {
                return (
                    <ConfigProvider>
                        <div style={{ width: "100%", padding: "25px" }}>
                            <Divider orientation="left" style={{ fontSize: "18px" }}>发送体检通知</Divider>
                            <Row style={{ marginTop: "15px" }}>
                                <Col span={2}></Col>
                                <Col span={20}>
                                    <Form onFinish={this.onFinish} ref={this.formRef}>
                                        <Form.Item
                                            label="体检模板名称"
                                            name="physicalExaminationMsgTemplateSelect"
                                            required
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "请选择体检模板",
                                                },
                                            ]}
                                        >
                                            <Select
                                                allowClear
                                                placeholder="---请选择---"
                                                onChange={this.physicalExaminationMsgTemplateSelectedChanged}
                                            >
                                                {this.state.physicalExaminationMsgTemplates.map((item) => (
                                                    <Select.Option key={item.name} value={item.code}>
                                                        {item.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label="发送方式"
                                            name="physicalExaminationSendTypeSelect"
                                            required rules={[
                                                {
                                                    required: true,
                                                    message: "请选择发送方式",
                                                },
                                            ]}>
                                            <Space>
                                                <Radio.Group options={this.state.options} onChange={this.onRadioChange} value={this.state.sendType} />
                                            </Space>
                                        </Form.Item>
                                        <Form.Item label="邮件预览">
                                            <UmRichEditor
                                                id="rich-basic-usage"
                                                toolbar={[]}
                                                autoHeightEnabled={true} // 高度自适应,默认为true
                                                height="200" // 自定义高度为500
                                                editStatus={false} // 默认为true,可以显式设置为false来禁用编辑功能
                                                defaultValue={this.state.emailContent}
                                                value={this.state.emailContent}
                                            />
                                        </Form.Item>
                                        <Form.Item label="短信预览">
                                            <UmRichEditor
                                                id="rich-basic-sms"
                                                toolbar={[]}
                                                autoHeightEnabled={true} // 高度自适应,默认为true
                                                height="200"
                                                editStatus={false} // 默认为true,可以显式设置为false来禁用编辑功能
                                                defaultValue={this.state.smsContent}
                                                value={this.state.smsContent}
                                            />
                                        </Form.Item>
                                        <Form.Item>
                                            <Space style={{ float: "right" }}>
                                                <Button onClick={() => closeModel("取消操作")}> 取消 </Button>
                                                <Button disabled={!this.state.btnEnable} htmlType="submit" type="primary">
                                                    提交
                                                </Button>
                                            </Space>
                                        </Form.Item>
                                    </Form>
                                </Col>
                                <Col span={2}></Col>
                            </Row>
                        </div>
                    </ConfigProvider>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}